import { axiosInstance } from "./axios";
import { ItemKind } from "dto/IKindItems";
import useCustomMutation from "hooks/useCustomMutation";

export interface ICaseGetFile {
  Url: string;
  Uri: string;
  FileName: string;
  ContentType: string;
  Bucket: string;
}

const getFile = ({
  id,
  ownerKind,
  callback,
}: {
  id: string;
  ownerKind: ItemKind;
  callback?: (progress: any) => void;
}): Promise<{ data: ICaseGetFile }> => {
  return axiosInstance.get(`/file?id=${id}&ownerKind=${ownerKind}`, {
    onDownloadProgress: (progress) => {
      callback?.(progress);
    },
  });
};

const useGetFile = () => {
  return useCustomMutation(getFile);
};

const useGetContactMessageChatFile = () => {
  return useCustomMutation(getContactMessageChatFile);
};

const getContactMessageChatFile = ({
  id,
  ownerKind,
  token,
  callback,
}: {
  id: string;
  ownerKind: ItemKind;
  token: string;
  callback?: (progress: any) => void;
}): Promise<{ data: ICaseGetFile }> => {
  return axiosInstance.get(
    `/contactForm/chat/file?id=${id}&ownerKind=${ownerKind}&token=${token}`,
    {
      onDownloadProgress: (progress) => {
        callback?.(progress);
      },
    },
  );
};

export interface IGetS3 {
  uri: string;
  partNumber: number;
  uploadId: string;
}

const getS3 = (payload: IGetS3): Promise<{ data: string }> => {
  return axiosInstance.get(
    `/file/part?uri=${payload.uri}&partNumber=${payload.partNumber}&uploadId=${payload.uploadId}`,
  );
};

const useGetS3 = () => {
  return useCustomMutation(getS3);
};

export interface IFilePart {
  ETag: string;
  PartNumber: number;
}
export interface IFileConfirm {
  Parts: IFilePart[];
  UploadId: string;
  Uri: string;
}

const confirmUpload = (payload: IFileConfirm) => {
  return axiosInstance.post("/file/confirm", payload);
};

const useConfirmUpload = () => {
  return useCustomMutation(confirmUpload);
};

export interface IFileInitUpload {
  ContentType: string;
  FileName: string;
  Hash: string;
  IsSigned: boolean;
  KeyId: string;
  Size: number;
  Queue: number;
}

export interface IFileInitUploadResponse {
  UploadId: string;
  Uri: string;
}

const initUpload = (
  payload: IFileInitUpload,
): Promise<{ data: IFileInitUploadResponse }> => {
  return axiosInstance.post("/file/init", payload);
};

const useInitUpload = () => {
  return useCustomMutation(initUpload);
};

export interface IUpdateLabel {
  OwnerId: string;
  OwnerKind: number;
  AttachmentId: string;
  Label: string;
}

const updateAttachment = (payload: IUpdateLabel) => {
  return axiosInstance.post("/attachment/label", payload);
};

const useUpdateAttachment = () => {
  return useCustomMutation(updateAttachment);
};

export default {
  useGetFile,
  useGetContactMessageChatFile,
  useInitUpload,
  useGetS3,
  useConfirmUpload,
  useUpdateAttachment,
  getFile,
};
